import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getSessionSummary = payload =>
  api.get(`/platform/edu/course-record/${payload.sessionToken}`, payload)

const getCourseDetails = payload =>
  api.get(
    `/platform/edu/course-record-detail/${payload.sessionToken}/${payload.courseRecordDetailId}`,
    payload,
  )

const updateCourseWatch = payload =>
  api.put(
    `/platform/edu/course-record-detail/${payload.sessionToken}/${payload.courseRecordDetailId}`,
    payload.data,
  )

const rateCourse = payload =>
  api.post(
    `/platform/edu/course-record-detail/${payload.sessionToken}/${payload.courseRecordDetailId}`,
    null,
    { params: payload.data },
  )

const getCourseProgramDetails = payload =>
  api.get(`/platform/course-program/${payload.courseId}/${payload.accountId}`, payload)

export default {
  getSessionSummary,
  getCourseDetails,
  updateCourseWatch,
  rateCourse,
  getCourseProgramDetails,
}
